<script>
    import app from "../stores/app";
    import PriceControl from "../components/controls/PriceControl.svelte";

    export let value;

    let vehicles = [];

    $app.vehicle_types.map(item => {
        let vehicle = value.find(x => x.id == item.id);
        if (!vehicle) {
            vehicle = {id: item.id, name: item.name, price: 0, start_price: 0};
        } else {
            vehicle.name = item.name;
        }
        vehicles.push(vehicle);
    });

    $: {
        value = [];
        vehicles.map(item => {
            if (item.price > 0) {
                value.push({
                    id: item.id,
                    price: item.price,
                    start_price: item.start_price,
                })
            }
        });
    }
</script>

<table class="table table-list mb-2">
    <tbody>
    {#each vehicles as vehicle}
        <tr class="row-hover">
            <td class="px-0 py-1">
                <div class="fw-semibold mb-1">{vehicle.name}</div>
                <div class="d-flex gap-2">
                    <div>
                        <div class="small mb-1">Offer price</div>
                        <PriceControl bind:value={vehicle.price} cssClass="form-control-sm" warnOnEmpty/>
                    </div>
                    <div>
                        <div class="small mb-1">Start price</div>
                        <PriceControl bind:value={vehicle.start_price} cssClass="form-control-sm" warnOnEmpty/>
                    </div>
                </div>
            </td>
        </tr>
    {/each}
    </tbody>
</table>

